import { createStyles } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },
  accordionControl: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  // mymodal: {
  //   width: "100%",
  //   overflow: "visible",
  //   "& .mantine-Modal-content": {
  //     // overflowY: "visible !important"

  //   },
  //   "& .mantine-Modal-inner": {
  //     padding: "px !important",
  //   },
  //   "& .mantine-Modal-header": {
  //     zIndex: 100,
  //   },
  // mymodal: {
  //   "& .mantine-Drawer-content": {
  //     borderRadius: "20px !important",
  //     // margin: "20px 20px 40px 0px",
  //     // backgroundColor: "#E5E5E5",
  //   },
  //   width: "100%",
  //   margin: "10px",
  //   overflow: "auto",
  //   height: "100%",
  //   borderRadius: "1rem 1rem 1rem 1rem",
  //   boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",

  //   // "& .mantine-Modal-content": {
  //   //   height: "300px !important",
  //   // },
  //   // "& .mantine-Modal-inner": {
  //   //   padding: "0px !important",
  //   // },
  //   "& .mantine-Paper-root": {
  //     overflow: "initial !important",
  //   },
  //   "& .mantine-Modal-inner": {
  //     // padding: "0px !important",
  //   },
  //   "& .mantine-Modal-header": {
  //     display: "none",
  //   },
  //   "& .mantine-Modal-body": {
  //     height: "90vh ",
  //     overflowY: "auto",
  //     padding: "0",
  //     background: "#F2F2F2",
  //     borderRadius: "1rem",
  //     // "@media (min-width: 2560px)": {
  //     //   height: "80vh !important",
  //     // },
  //   },

  //   "@media (max-width:400px)": {
  //     width: "auto",
  //   },
  //   "& .mantine-1q36a81": {
  //     padding: "0",
  //   },
  //   // "@media (max-width: 400px)": {
  //   //   width: "auto",
  //   // },
  //   // "@media (min-width: 1440px)": {
  //   //   height: "50vh",
  //   // },
  //   // "@media (min-width: 1920px)": {
  //   //   height: "45vh",
  //   // },
  //   // "@media (max-width: 2560px)": {
  //   //   minHeight: "100vh !important",
  //   // },
  // },

  mymodal: {
    "& .mantine-Drawer-inner .mantine-Drawer-content": {
      display: "flex",
      flexDirection: "column",
      overflowY: "hidden",
    },
    "& .mantine-Drawer-header": {
      flex: "none",
      backgroundColor: "var(--app-surface)",
      padding: "17px 22px",
      borderBottom: "1px solid var(--app-border)",
      "& .mantine-CloseButton-root": {
        width: "34px !important",
        height: "34px !important",
        borderRadius: "9px !important",
        color: "var(--app-text-muted)",
        "&:hover": {
          backgroundColor: "var(--app-surface-2)",
        },
        "& svg": {
          height: "20px !important",
          width: "20px !important",
        },
      },
    },
    "& .mantine-Drawer-body": {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      display: "flex",
      flexDirection: "column",
      padding: "20px 20px 0px 20px !important",
      "@media (max-width: 600px)": {
        padding: "16px 12px !important",
      },
    },
    "& .mantine-Drawer-title": {
      fontSize: "21px",
      fontWeight: "700",
      color: "var(--app-text)",
      fontFamily: "Inter",
    },
    "& .mantine-Drawer-content": {
      borderRadius: "18px 0 0 18px !important",
      backgroundColor: "var(--app-bg)",
      boxShadow: "-8px 0 40px rgba(0,0,0,.25)",
    },
    width: "100%",
    margin: "10px",
    overflow: "auto",
    height: "100%",
    "@media (max-width: 600px)": {
      margin: 0,
    },
    "& .mantine-1as9nn9": {
      backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    },

    "& .mantine-Drawer-inner": {
      right: 0,
      // top:15,
      // right:15,
      // "& section": {
      //   height:'calc(100% - 20px) !important',

      //   "& .mantine-1deqy7c":{
      //     height:'100% !important'
      //   }
      // },
    },

    // borderRadius: "1rem 1rem 1rem 1rem",
    // boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)",
    // "& .mantine-Modal-content": {
    //   height: "300px !important",
    // },
    // "& .mantine-Modal-inner": {
    //   padding: "0px !important",
    // },

    "& .mantine-ScrollArea-viewport": {
      background: "var(--app-surface-2)",
    },
    // "& .mantine-Paper-root": {
    //   overflow: "initial !important",
    // },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-Modal-header": {
      // display: "inline",
      borderRadius: "15px",
    },
    "& .mantine-Modal-body": {
      // height: "90vh ",
      overflowY: "auto",
      // padding: "0",
      background: "var(--app-surface-2)",
      borderRadius: "1rem",
      // "@media (min-width: 2560px)": {
      //   height: "80vh !important",
      // },
    },

    "@media (max-width:400px)": {
      width: "auto",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
    // "@media (max-width: 400px)": {
    //   width: "auto",
    // },
    // "@media (min-width: 1440px)": {
    //   height: "50vh",
    // },
    // "@media (min-width: 1920px)": {
    //   height: "45vh",
    // },
    // "@media (max-width: 2560px)": {
    //   minHeight: "100vh !important",
    // },
  },

  formStyling: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  noteFieldsBox: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
  },

  noteType: {
    padding: "12px 12px 20px 12px !important",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    "& .mantine-Select-root": {
      fontFamily: "Inter",
      "& .mantine-Select-label": {
        color: "#344054",
        fontSize: "13px",
        fontWeight: 500,
        width: "100%",
        textAlign: "start",
      },
      "& .mantine-Select-wrapper": {
        marginTop: "7px",
        height: "auto",
        backgroundColor: "var(--app-surface)",
        borderRadius: "8px",
        border: "1px solid var(--app-border)",
        "&:focus-within": {
          borderColor: "var(--app-primary)",
          boxShadow: "0 0 0 3px rgba(255,175,74,.2)",
        },
      },
      "& input": {
        border: "none",
        backgroundColor: "transparent",
        paddingBlock: "10px",
        color: "var(--app-text)",
        fontSize: "14px",
        fontWeight: 400,
        paddingLeft: "14px",
        height: "44px",
      },
      "& .mantine-Select-rightSection": {
        width: "fit-content",
        height: "inherit",
        marginRight: "14px",
      },
    },
  },

  select: {
    fontFamily: "Inter",
    "& .mantine-Select-label": {
      color: "#344054",
      fontSize: "13px",
      fontWeight: 500,
      fontFamily: "Inter",
      width: "100%",
      textAlign: "start",
    },
    "& .mantine-Select-wrapper": {
      marginTop: "7px",
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      "&:focus-within": {
        borderColor: "var(--app-primary)",
        boxShadow: "0 0 0 3px rgba(255,175,74,.2)",
      },
    },
    "& input": {
      border: "none",
      backgroundColor: "transparent",
      paddingBlock: "10px",
      color: "var(--app-text)",
      fontSize: "14px",
      fontWeight: 400,
      paddingLeft: "14px",
      height: "44px",
    },
    "& .mantine-Select-rightSection": {
      width: "fit-content",
      height: "inherit",
      marginRight: "14px",
    },
  },
  // Add-on to `select` for a Select that shares a Grid row with a Client/Staff
  // MultiSelect (Facility Name), which is 6px taller. Where that 6px comes from:
  //
  //   client  = 40px (Mantine sizes MultiSelect's inner `values` box at
  //             md input height − 2px) + 12px (gcMultiSelect's 6px/6px input
  //             padding) + 0  (its wrapper border rule doesn't apply — see the
  //             selector note on gcMultiSelect)          = 52px
  //   select  = 44px (input height) + 2px (wrapper border) = 46px
  //
  // So the input goes to 50px here and the wrapper border makes up the 52nd.
  // Written as `.mantine-Select-input` (two classes) so it out-specifies
  // `select`'s `& input` rule above regardless of stylesheet order.
  selectTall: {
    "& .mantine-Select-input": {
      height: "50px",
    },
  },
  input: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      "&:focus-within": {
        borderColor: "var(--app-primary)",
        boxShadow: "0 0 0 3px rgba(255,175,74,.2)",
      },
      "& .mantine-Input-input": {
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        fontFamily: "Inter",
        color: "var(--app-text)",
        fontSize: "14px",
        fontWeight: 400,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#344054",
      marginBottom: "7px",
      fontFamily: "Inter",
      fontSize: "13px",
      fontWeight: 500,
      width: "100%",
      textAlign: "start",
    },
  },
  view_input: {
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "3px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
      width: "100%",
      textAlign: "start",
    },
  },
  outcomeDeleteBTN: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "flex-end",
    borderRadius: "8px",
    background: "var(--app-surface-2)",
    padding: "8px",
    "& .mantine-Text-root": {
      padding: "8px 0px",
      display: "flex",
      alignItems: "center",
      fontWeight: 600,
      gap: 4,
      fontSize: "16px",
      color: "#F04438",
      cursor: "pointer",
      fontFamily: "Inter",
    },
  },
  goalsTextArea: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      borderRadius: "8px 8px 8px 8px",
      padding: "10px 0 10px",
      backgroundColor: "var(--app-surface)",
      border: "1px solid var(--app-border)",
      boxShadow:
        "0px -1px 2px 0px rgba(16, 24, 40, 0.05), -1px 0px 2px 0px rgba(16, 24, 40, 0.05), 1px 0px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        borderRadius: "8px 8px 0px 0px",
        fontFamily: "Inter",
        padding: "0 10px",
        border: "none",
        color: "var(--app-text-muted)",
        fontSize: "12px",
        fontWeight: 400,
        height: "150px",
        textAlign: "justify",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  essentialDiscriptionArea: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      borderRadius: "8px",
      padding: "10px 0 10px",
      backgroundColor: "var(--app-surface)",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        borderRadius: "8px",
        fontFamily: "Inter",
        padding: "0 10px",
        border: "none",
        color: "var(--app-text-muted)",
        fontSize: "12px",
        fontWeight: 400,
        height: "150px",
        textAlign: "justify",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "var(--app-text)",
      marginBottom: "8px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  essentialViewInfoAccordion: {
    marginBottom: "26px !important",
    borderRadius: 8,
    background: "rgba(247, 247, 247, 0.60)",
    "& .mantine-Accordion-label": {
      display: "flex",
      alignItems: "center",
      gap: 7,
      color: "var(--app-text)",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 400,
      "& svg": {
        height: "18px",
        width: "18px",
        marginBottom: "0px !important",
      },
    },
    "& .mantine-Accordion-chevron svg": {
      color: "var(--app-text)",
    },
  },
  datePicker: {
    fontFamily: "Inter",
    "& .mantine-Input-wrapper": {
      marginTop: "7px",
      height: "auto",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      "&:focus-within": {
        borderColor: "var(--app-primary)",
        boxShadow: "0 0 0 3px rgba(255,175,74,.2)",
      },

      "& .mantine-DatePickerInput-input": {
        padding: "10px 14px",
      },
      "& .mantine-Input-input": {
        backgroundColor: "transparent",
        border: "none",
        height: "44px",
        color: "var(--app-text)",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 600,
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#344054",
      fontFamily: "Inter",
      fontSize: "13px",
      fontWeight: 500,
    },
  },
  approved: {
    backgroundColor: "var(--app-tint-green)",
  },
  rejected: {
    background: "var(--app-tint-red)",
  },
  pending: {
    background: "var(--app-surface)",
  },
  mwd: {
    // background: "red",
    width: "100%",
    textAlign: "start",
    "& .mantine-Modal-header": {
      zIndex: 100,
    },
    "@media (max-width: 600px)": {
      width: "100% !important",
      flexDirection: "column",
    },
  },
  // Intentionally no content-padding override here — matches Progress
  // Note's Outcome accordion, which relies on Mantine's own default
  // Accordion.Panel padding instead of a custom one.
  essentialAccordion: {},
  myfont: {
    fontFamily: "Inter",
    overflow: "auto",

    "& .mantine-Textarea-input": {
      background: "var(--app-surface-2)",
      color: "var(--app-text-muted)",
    },
  },
  disabledTextarea: {
    overflowY: "auto",
    resize: "none",
    cursor: "not-allowed",
    // backgroundColor: "red",
  },
  viewTextArea: {
    minHeight: "100px",
    height: "100px",
  },
  descriptionIcon: {
    position: "absolute",
    top: 10,
    left: 10,
  },
  labelTextarea: {
    fontWeight: "500",
    paddingBottom: "10px",
    margin: "0 !important",
  },
  infoLabel: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  // header: {
  //   width: "100%",
  //   display: "flex",
  //   justifyContent: "center",
  //   alignItems: "center",
  //   background: "#f4ead8",
  //   overflow: "hidden",
  //   borderRadius: "1rem 1rem 0 0",
  //   height: "80px",
  //   gap: "20px",
  //   "& h2": {
  //     margin: "0",
  //     fontSize: "20px",
  //   },
  // },
  newDesignHeader: {
    width: "100%",
    display: "flex",
    paddingLeft: "20px",
    alignItems: "center",
    background: "var(--app-surface)",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "80px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "20px",
    },
  },
  modalTopHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
  },
  staffContainer: {
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    width: "100%",
    // gap: "5px",
  },

  userDetails: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    // padding: "0 1rem",
  },
  textInputBox: {
    backgroundColor: "var(--app-surface)",
    width: "100%",
    marginTop: "10px",
    border: "1px solid rgba(0,0,0,0.1)",
    padding: "5px 15px",
    borderRadius: "15px",
    position: "relative",
    "& textarea[disabled]": {
      backgroundColor: "var(--app-surface) !important",
    },
    "& .mantine-Textarea-input": {
      border: "none",
      paddingInline: "0",
    },
    "& .label": {
      position: "absolute",
      borderRadius: "5px",
      top: -10,
      left: 15,
      zIndex: 100,
      color: "var(--app-text)",
      margin: 0,
      backgroundColor: "var(--app-surface)",
      display: "inline-block",
      fontSize: "14px",
      fontWeight: 500,
      paddingInline: "10px",
    },
  },
  modalContentBG: {
    borderRadius: "1rem",
    margin: "1rem 0",
    // width:"calc(100% - 2.5rem)",
    // boxSizing:'border-box'
  },
  accordionTitle: {
    background: "var(--app-surface-2)",
    padding: ".5rem",
    borderRadius: "5px",
  },
  // Care-plan reference box (mockup `.cpinfo`) shown inside outcome/support/goal cards
  cpinfo: {
    border: "1px solid var(--app-border)",
    borderRadius: "14px",
    background: "var(--app-surface)",
    margin: "6px 0 2px",
    overflow: "hidden",
  },
  cpinfoHead: {
    background: "var(--app-surface-2)",
    borderBottom: "1px solid var(--app-border)",
    cursor: "pointer",
  },
cpinfoBody:{
paddingTop: "11px"
},
  // Mantine's Accordion.Control wraps children in its own internal
  // <span class="label"> (display not set to flex) — this wrapper forces
  // the badge+text row regardless of that internal element's own layout.
  cpinfoHeadRow: {
    display: "flex",
    alignItems: "center",
    gap: "11px",
    width: "100%",
  },
  cpinfoBadge: {
    flex: "none",
    width: "30px",
    height: "30px",
    borderRadius: "9px",
    display: "grid",
    placeItems: "center",
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    color: "var(--app-text-muted)",
  },
  cpinfoHtext: {
    display: "flex",
    flexDirection: "column",
    lineHeight: 1.3,
    minWidth: 0,
  },
  cpinfoEyebrow: {
    fontFamily: "Inter",
    fontSize: "9.5px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.07em",
    color: "var(--app-text-faint, #8A93A2)",
  },
  cpinfoTitle: {
    fontFamily: "Inter",
    fontSize: "13.5px",
    fontWeight: 600,
    color: "var(--app-text)",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  cpinfoChevron: {
    marginLeft: "auto",
    flex: "none",
    transition: "transform 0.2s",
    color: "var(--app-text-faint, #8A93A2)",
    "&[data-active]": {
      transform: "rotate(180deg)",
    },
  },
  cpinfoGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    marginBottom: "10px",
  },
  cpinfoGridLeft: {
    paddingRight: "18px",
    borderRight: "1px solid var(--app-border)",
  },
  cpinfoGridRight: {
    paddingLeft: "18px",
  },
  cpinfoLbl: {
    fontFamily: "Inter",
    fontSize: "10px",
    fontWeight: 700,
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    color: "var(--app-text-faint, #8A93A2)",
    marginBottom: "5px",
  },
  cpinfoVal: {
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text)",
    lineHeight: 1.55,
  },
  cpinfoFoot: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginTop: "15px",
    paddingTop: "13px",
    borderTop: "1px solid var(--app-border)",
  },
  cpinfoPill: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    color: "var(--app-text)",
    background: "var(--app-surface-2)",
    border: "1px solid var(--app-border)",
    borderRadius: "20px",
    padding: "3px 12px",
  },
  cpinfoFootLbl: {
    marginBottom: 0,
  },

  accordionItem: {
    background: "var(--app-bg)",
    border: "1px solid var(--app-border)",
    borderRadius: "10px",
    marginBottom: "10px",
    overflow: "hidden",
    position: "relative",
    // padding: "14px",
    "& .mantine-hp9ccp[data-active=true]": {
      // borderRadius: "10px !important",
      position: "absolute",
      width: "fit-content",
      right: 0,
    },
    // "& .accordionCon": {
    //   // borderRadius: "10px !important",
    //   position:"absolute"
    // },
  },
  addNoteAccordionItem: {
    "& .mantine-hp9ccp[data-active=true]": {
      // borderRadius: "10px !important",
      position: "static",
      width: "100%",

      "& ..mantine-p2utts": {
        display: "none",
      },
    },
  },
  essentialAccordionItem: {
    background: "var(--app-bg)",
    border: "1px solid var(--app-border)",
    borderRadius: "10px",
    marginBottom: "10px",
    overflow: "hidden",
  },
  accDeleteBtn: {
    border: "none",
    background: "none",
    color: "var(--app-text-faint)",
    cursor: "pointer",
    padding: "2px",
    borderRadius: "6px",
    "&:hover": {
      color: "#B42318",
      background: "#FEF3F2",
    },
  },
  howOftenClass: {
    border: "1px solid var(--app-border)",
    padding: "0 .5rem",
    borderRadius: "10px",
    marginBottom: "1rem",
    marginTop: ".3rem",
    width: "100%",
  },
  accordionInput: {
    border: "1px solid var(--app-border)",
    padding: "0 .5rem",
    borderRadius: "10px",
    height: "fit-content",
    marginBottom: "1rem",
    marginTop: ".3rem",
    width: "100%",
    // overflowY: "auto",
    // height: "150px",
  },
  activityContainer: {
    display: "flex",
    justifyContent: "center",
    // alignItems: "center",
    gap: "10px",
    width: "100%",
    height: "100%",
  },
  radioGroup: {
    border: "1px solid var(--app-border)",
    borderRadius: "10px",
  },
  selectBG: {
    padding: "5px",
    borderRadius: "5px",
    width: "100%",

    "& .mantine-1ejqehl .mantine-Input-wrapper input": {
      fontWeight: "900",
      background: "red",
    },
  },
  accordionRowWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },

  accordionRowSingleLine: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },

  accordionRowSingleLineText: {
    flex: 1,
  },

  accordianSingleLineBox: {
    width: '100%',
  },
  infoAccordion: {
    height: "250px",
    overflowY: "auto",
  },
  outcomeText: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    color: "#212529",
  },
  outcomeContainer: {
    // background: "#f1f3f5",
    padding: "5px",
    borderRadius: "5px",
    marginTop: "3px",
    width: "100%",
  },
  staffOnEdit: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  responsiveBtn: {
    "@media (min-width:992px)": {
      display: "block",
      marginLeft: "auto",
    },
    "@media (max-width:992px)": {
      display: "block",
      margin: "0 auto",
      width: "50%",
    },
  },

  essentialResponsiveBtn: {
    marginLeft: "auto",
    display: "block",
    marginTop: "10px",
    borderRadius: "8px",
    backgroundColor: "color-mix(in srgb, var(--app-primary) 88%, #000)",
    color: "var(--app-on-primary)",
    "@media (min-width:992px)": {
      display: "block",
      marginLeft: "auto",
    },
    "@media (max-width:992px)": {
      display: "block",
      margin: "0 auto",
      width: "50%",
    },
  },
  cancelAndSupportParent: {
    margin: "0 16px 0 16px",
  },
  saveAndCancelParent: {
    backgroundColor: "red",
    width: "100%",
  },
  saveNoteBtn: {
    flex: 1,
    margin: 0,
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    borderRadius: "9px",
    padding: "13px",
    justifyContent: "center",
    height: "auto",
    border: "1px solid var(--app-primary)",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    "&:hover": {
      backgroundColor: "var(--app-primary-hover, #fab005) !important",
    },
    "@media (max-width: 480px)": {
      fontSize: "13px",
    },
  },
  cancelNoteBtn: {
    flex: 1,
    margin: 0,
    backgroundColor: "var(--app-surface)",
    borderRadius: "9px",
    padding: "13px",
    justifyContent: "center",
    border: "1px solid var(--app-border)",
    color: "var(--app-text)",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    height: "auto",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
    "@media (max-width: 480px)": {
      fontSize: "13px",
    },
  },
  essentialSupportParent: {
    borderRadius: "10px",
    margin: "1rem",
    padding: "1rem",
    background: "var(--app-surface)",
  },
  rejectionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    justifyContent: "end",
    alignItems: "flex-end",
    // margin: "0 1rem",
  },
  rejectionBox: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: ".5rem",
    backgroundColor: "var(--app-surface)",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    borderStyle: "solid",
  },
  rejection: {
    backgroundColor: "var(--app-tint-red)",
    borderRadius: "10px",
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "1rem",
  },
  crossIcon: {
    cursor: "pointer",
  },
  rejectedNote: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center",
    gap: ".5rem",
    backgroundColor: "var(--app-surface)",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    margin: "1rem 0",
  },
  approvedNote: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: ".5rem",
    backgroundColor: "var(--app-surface)",
    borderRadius: "10px",
    padding: "1rem",
    borderColor: "#E5E5EA",
    borderWidth: "2px",
    margin: "1rem 1rem",
  },
  btns: {
    display: "flex",
    gap: "1rem",
    justifyContent: "flex-end",
    margin: "1rem",
  },
  rejectionIconBox: {
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    gap: "1rem",
  },
  rejectionBoxReason: {
    display: "flex",
    flexDirection: "column",
    gap: ".3rem",
    alignContent: "start",
    justifyContent: "start",
  },
  // staffField: {
  //   margin: "0 20px",
  // },
  outcomeTitle: {
    background: "var(--app-bg)",
    padding: "10px",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    margin: "10px 0",
    justifyContent: "space-between",
    border: "1px solid #E7EBEF",
  },
  outcomeTitleView: {
    background: "var(--app-surface)",
    padding: "10px",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    // margin: "10px 0",
    justifyContent: "space-between",
    border: "1px solid #E7EBEF",
  },
  outcomeNote: {
    background: "var(--app-bg)",
    padding: "10px",
    borderRadius: "8px",
    fontWeight: 600,
    fontSize: "16px",
    margin: "10px 0",
    height: "200px",
    overflowY: "scroll",
    border: "1px solid #E7EBEF",
  },
  accordionDeleteBtn: {
    backgroundColor: "transparent",
    color: "red",
    border: "none",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  deleteIcon: {
    marginRight: "5px",
  },
  deleteBtnParent: {
    backgroundColor: "#f7f7f7",
    borderRadius: "5px",
    display: "flex",
    justifyContent: "flex-end",
  },
  // Matches mockup's `.btn` (full width, inline "+ Add New X" affordance
  // inside the outcome/support/goal card, below the accordion items).
  addNewOutcomeBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "7px",
    width: "100%",
    height: "auto",
    margin: 0,
    borderRadius: "9px",
    padding: "9px 14px",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    color: "var(--app-text)",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },
  progressNoteSaveBtn: {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    width: "50%",
    height: "40px",
    borderRadius: "6px",
    "&:hover": {
      backgroundColor: "var(--app-primary)",
    },
  },
  textAreaStyling: {
    width: "100% !important",
    borderRadius: "10px",
  },
  groupedButtonsParent: {
    backgroundColor: "var(--app-surface)",
    padding: "16px 20px",
    gap: "12px",
    borderTop: "1px solid var(--app-border)",
    display: "flex",
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    marginTop: "auto",
    marginLeft: "-20px",
    marginRight: "-20px",
    marginBottom: "-20px",
    width: "calc(100% + 40px)",
  },
  supportPlanGroupedButtons: {
    backgroundColor: "var(--app-surface)",
    padding: "10px",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
    borderTop: "1px solid var(--app-border)",
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px`,
    marginBottom: "10px",
    display: "flex",
  },
  detailsForm: {
    backgroundColor: "var(--app-surface)",
    borderRadius: "16px",
    border: "1px solid var(--app-border)",
    padding: "20px 13px 19px 13px",
  },
  radioGroupParent: {
    "& .mantine-Text-root": {
      color: "#344054",
      fontSize: "13px",
      fontWeight: 500,
      fontFamily: "Inter",
      marginTop: "5px",
      marginBottom: "7px",
    },
    "& .radioGroupStyling": {
      border: "1px solid #ccc",
      padding: "12px",
      borderRadius: "7px",
      marginTop: "1px",
      height: "44px",
      backgroundColor: "var(--app-surface-2)",
      "& .mantine-Radio-label": {
        color: "var(--app-text)",
        fontSize: "14px",
        fontFamily: "Inter",
        fontWeight: 500,
      },
      "& .mantine-Radio-radio:checked": {
        backgroundColor: "var(--app-primary)",
        borderColor: "var(--app-primary)",
      },
    },
  },
  supportPlanAccordion: {
    maxHeight: "100%",
    backgroundColor: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "16px",
    padding: "18px 15px",
    margin: "18px 15px 15px 15px",
    "@media (max-width: 600px)": {
      margin: "18px 8px 15px 8px",
    },
  },
  noteTypeCompParent: {
    margin: "15px 22px 10px 14px",
    "@media (max-width: 600px)": {
      margin: "15px 8px 10px 8px",
    },
  },
  noteSelected: {
    margin: "15px 12px 10px 14px",
  },
  my: {
    margin: "2rem 0",
  },
  noteViewNewDrawer: {
    // "& .mantine-Drawer-header": {
    //   backgroundColor: "#FFF",
    //   padding: "19px 13px",
    //   "& .mantine-CloseButton-root svg": {
    //     height: "20px !important",
    //     width: "20px !important",
    //   },
    // },
    "& .mantine-Drawer-body": {
      padding: "0px !important",
    },
    "& .mantine-Drawer-title": {
      fontSize: "24px",
      fontWeight: "700",
      color: "var(--app-text)",
      fontFamily: "Inter",
    },
    "& .mantine-Drawer-content": {
      borderRadius: "13px !important",
      backgroundColor: "var(--app-bg)",
    },
    width: "100%",
    margin: "10px",
    overflow: "auto",
    height: "100%",
    "@media (max-width: 600px)": {
      margin: 0,
    },
    "& .mantine-1as9nn9": {
      backgroundColor: "rgba(0, 0, 0, 0.1) !important",
    },

    "& .mantine-Drawer-inner": {
      right: 0,
    },
  },
  // Read-only field display in the view drawer (mockup `.vlabel` / `.vval`)
  timeDateView: {
    "& .mantine-Input-input": {
      minHeight: "auto",
      height: "auto",
      lineHeight: "normal",
      color: "var(--app-text)",
      fontSize: 14,
      fontWeight: 500,
      fontFamily: "Inter",
      padding: 0,
    },
    "& .mantine-InputWrapper-label": {
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      color: "var(--app-text-faint, #8A93A2)",
      marginBottom: 3,
    },
  },
  waveSection: {
    marginTop: theme.spacing.md,
    padding: theme.spacing.md,
    // backgroundColor: "#F9FAFB",
    // border: "1px solid #D0D5DD",
    // borderRadius: 8,
  },

  wave: {
    display: "flex",
    alignItems: "end",
    gap: 4,
    height: 50,
    marginBottom: theme.spacing.md,
  },

  bar: {
    width: 4,
    borderRadius: 2,
    backgroundColor: "var(--app-primary)",
    animation: "wave 1.2s infinite ease-in-out",
  },

  "@keyframes wave": {
    "0%, 100%": { height: "60%" },
    "50%": { height: "100%" },
  },

  waveButtons: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
  },
  signatureImg: {
    width: 250,
    height: "auto",
    marginTop: 20,
    // Signatures are dark ink strokes — keep a white chip on every theme
    backgroundColor: "#FFFFFF",
    borderRadius: 8,
  },
  interventionGoalItem: {
    border: "1px solid var(--app-border)",
    padding: 10,
    borderRadius: 8,
  },
  interventionAddGoalItem: {
    display: "flex",
    width: 26,
    height: 26,
    padding: 0,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 35,
    backgroundColor: "var(--app-surface)",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
    "&:hover": {
      backgroundColor: "var(--app-surface)",
    },
  },
  goalItemsBox: {
    border: "1px solid var(--app-border)",
    padding: "10px",
    marginTop: "10px",
    borderRadius: "8px",
    textAlign: "justify"
  },

  // ── Group Clients multi-select ──────────────────────────────────────
  // Heads-up before editing the wrapper block below: Mantine builds an Input's
  // classes with `name: ["Input", "MultiSelect"]`, which puts BOTH
  // `mantine-Input-wrapper` and `mantine-MultiSelect-wrapper` on the SAME
  // element — so the `… -wrapper .mantine-Input-wrapper` descendant selector
  // matches nothing and none of its declarations (border, radius, margin-top,
  // shadow) currently render. `selectTall` above depends on that.
  gcMultiSelect: {
    fontFamily: "Inter",
    "& .mantine-MultiSelect-label": {
      color: "var(--app-text)",
      fontSize: "14px",
      fontWeight: 500,
      fontFamily: "Inter",
    },
    "& .mantine-MultiSelect-wrapper .mantine-Input-wrapper": {
      marginTop: "8px",
      backgroundColor: "var(--app-surface)",
      borderRadius: "8px",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    },
    "& .mantine-MultiSelect-input": {
      border: "none",
      backgroundColor: "transparent",
      minHeight: "44px",
      fontFamily: "Inter",
      fontSize: "14px",
      color: "var(--app-text)",
      padding: "6px 38px 6px 8px",
      "&:focus-within": {
        borderColor: "var(--app-primary)",
        boxShadow: "0 0 0 3px color-mix(in srgb, var(--app-primary) 15%, transparent)",
      },
    },
    "& .mantine-MultiSelect-searchInput": {
      fontFamily: "Inter",
      fontSize: "14px",
      color: "var(--app-text)",
      minHeight: "32px",
      "&::placeholder": {
        color: "var(--app-text-muted)",
      },
    },
    "& .mantine-MultiSelect-rightSection": {
      width: "fit-content",
      height: "inherit",
      marginRight: "14px",
    },
  },
  gcMsPill: {
    background: "#FFF6E9",
    border: "1px solid #FFE2B8",
    color: "#7A4A00",
    borderRadius: "16px",
    fontWeight: 500,
    fontSize: "13px",
    padding: "3px 6px 3px 10px",
    gap: "4px",
  },
  gcMsPillRemove: {
    background: "rgba(122, 74, 0, 0.12)",
    color: "#7A4A00",
    borderRadius: "50%",
    width: "16px !important",
    height: "16px !important",
    minWidth: "16px !important",
    minHeight: "16px !important",
    "&:hover": {
      background: "rgba(122, 74, 0, 0.25)",
    },
    "& svg": {
      width: "10px !important",
      height: "10px !important",
    }
  },
  gcMsItem: {
    fontFamily: "Inter",
    fontSize: "14px",
    color: "var(--app-text)",
    borderRadius: "8px",
    "&[data-hovered]": {
      background: "var(--app-surface-2)",
    },
    "&[data-selected]": {
      background: "#FFF6E9",
      color: "#7A4A00",
      "&[data-hovered]": {
        background: "#FFE2B8",
      },
    },
  },
  gcHint: {
    marginTop: "8px",
    fontSize: "12px",
    color: "var(--app-text-muted)",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "Inter",
  },
  gcBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    background: "#FFF6E9",
    border: "1px solid #FFE2B8",
    color: "#B47200",
    fontSize: "12px",
    fontWeight: 600,
    fontFamily: "Inter",
    padding: "3px 10px",
    borderRadius: "20px",
    marginLeft: "10px",
    verticalAlign: "middle",
  },
  incidentClassificationTitle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "var(--app-text)",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0.02em",
    marginBottom: "16px",
    textTransform: "uppercase",
    "& svg": {
      width: "15px",
      height: "15px",
      color: "var(--app-text-muted)"
    },
  },
  incidentSeverityLabel: {
    color: "var(--app-text)",
    fontSize: "14px",
    fontWeight: 500,
    fontFamily: "Inter",
    marginTop: "2px",
    marginBottom: "8px",
  },
  incidentSeverityGroup: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "10px",
    "@media (max-width: 600px)": {
      gridTemplateColumns: "repeat(2, 1fr)",
    },
  },
  incidentSeverityOption: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    padding: "10px 8px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 500,
    cursor: "pointer",
    userSelect: "none",
    height: "fit-content",
    minHeight: "fit-content",
  },
  incidentSeverityOptionActive:{
    fontWeight: 600,
  },
  incidentSeverityDot: {
    width: "8px",
    height: "8px",
    borderRadius: "50%",
    flexShrink: 0,
  },
  incidentRequiredMark: {
    color: "#F04438",
  },
  incidentRequiredPill: {
    display: "inline-flex",
    alignItems: "center",
    flexShrink: 0,
    padding: "1px 10px",
    borderRadius: "16px",
    border: "1px solid rgb(254, 205, 202)",
    backgroundColor: "rgb(254, 243, 242)",
    color: "rgb(180, 35, 24)",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: 1.6,
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },
  incidentYesNoGroup: {
    display: "flex",
    gap: "10px",
  },
  incidentYesNoOption: {
    flex: 1,
    height: "44px",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 8px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    userSelect: "none",
    transition: "0.15s",
  },
  incidentYesNoOptionActive: {
    borderColor: "rgb(255, 226, 184)",
    backgroundColor: "rgb(255, 246, 233)",
    color: "rgb(122, 74, 0)",
    fontWeight: 600,
  },
  incidentDivider: {
    border: "none",
    borderTop: "1px solid var(--app-border)",
    margin: "18px 0",
  },
  incidentSubSection: {
    marginTop: "14px",
    padding: "14px",
    borderRadius: "8px",
    border: "1px solid rgb(255, 226, 184)",
    backgroundColor: "rgb(255, 246, 233)",
  },
  incidentReportableBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    padding: "14px 16px",
    borderRadius: "8px",
    border: "1px solid",
    marginBottom: "16px",
    fontFamily: "Inter",
    "& svg": {
      flexShrink: 0,
      marginTop: "2px",
    },
  },
  incidentStaffPill: {
    background: "#EAECF5",
    border: "1px solid #D5D9EB",
    color: "#363F72",
    borderRadius: "16px",
    fontWeight: 500,
    fontSize: "13px",
    padding: "3px 6px 3px 10px",
    gap: "4px",
  },
  incidentStaffPillRemove: {
    background: "rgba(54, 63, 114, 0.12)",
    color: "#363F72",
    borderRadius: "50%",
    width: "16px !important",
    height: "16px !important",
    minWidth: "16px !important",
    minHeight: "16px !important",
    "&:hover": {
      background: "rgba(54, 63, 114, 0.25)",
    },
    "& svg": {
      width: "10px !important",
      height: "10px !important",
    },
  },
  incidentNotifyHint: {
    display: "flex",
    alignItems: "flex-start",
    gap: "8px",
    marginBottom: "16px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text-muted)",
    "& svg": {
      flexShrink: 0,
      marginTop: "2px",
    },
  },
  incidentNotifyGroupHeader: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "10px 0",
    marginTop: "10px",
  },
  incidentNotifyGroupIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    flexShrink: 0,
    "& svg": {
      width: "13px",
      height: "13px",
    },
  },
  incidentNotifyGroupLabel: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 700,
    letterSpacing: "0.02em",
    color: "var(--app-text-muted)",
    whiteSpace: "nowrap",
  },
  incidentNotifyGroupDivider: {
    flex: 1,
    height: "1px",
    background: "var(--app-border)",
    margin: "0 4px",
  },
  incidentNotifyGroupCount: {
    fontFamily: "Inter",
    fontSize: "12px",
    color: "var(--app-text-muted)",
    whiteSpace: "nowrap",
  },
  incidentNotifyRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "10px 6px",
    borderRadius: "8px",
    cursor: "pointer",
    "&:hover": {
      background: "var(--app-surface-2)",
    },
  },
  incidentNotifyAvatar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "34px",
    height: "34px",
    borderRadius: "50%",
    background: "rgb(255, 246, 233)",
    color: "rgb(181, 71, 8)",
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 600,
    flexShrink: 0,
  },
  incidentNotifyName: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 600,
    color: "var(--app-text)",
  },
  incidentNotifyCheckbox: {
    "& input:checked": {
      backgroundColor: "#ffaf4a !important",
      borderColor: "#ffaf4a !important",
    },
  },
  incidentNotifySub: {
    fontFamily: "Inter",
    fontSize: "12px",
    color: "var(--app-text-muted)",
  },
  incidentNotifyPhone: {
    marginLeft: "auto",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text-muted)",
    whiteSpace: "nowrap",
  },
  incidentPlainTextArea: {
    "& .mantine-Input-wrapper": {
      height: "auto",
      borderRadius: "8px",
      backgroundColor: "var(--app-surface)",
      border: "1px solid var(--app-border)",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        borderRadius: "8px",
        fontFamily: "Inter",
        padding: "12px 14px",
        border: "none",
        color: "var(--app-text)",
        fontSize: "13px",
        fontWeight: 400,
        lineHeight: 1.5,
      },
    },
  },
  incidentStaffItem: {
    fontFamily: "Inter",
    fontSize: "14px",
    color: "var(--app-text)",
    borderRadius: "8px",
    "&[data-hovered]": {
      background: "var(--app-surface-2)",
    },
    "&[data-selected]": {
      background: "#EAECF5",
      color: "#363F72",
      "&[data-hovered]": {
        background: "#D5D9EB",
      },
    },
  },
  incidentSeverityBadge: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    marginLeft: "10px",
    padding: "3px 10px",
    borderRadius: "20px",
    border: "1px solid var(--app-text)",
    fontFamily: "Inter",
    color: "var(--app-text)",
    fontSize: "12px",
    fontWeight: 600,
    verticalAlign: "middle",
  },

  clockIcon: {
    width: "20px",
  },
  popoverInfoTarget: {
    marginBottom: "10px",
  },
  medicationInfoTextarea: {
    height: "200px !important",
    marginTop: "10px",
  },

  goalItemBtnDisabled: {
    opacity: 0.5,
    pointerEvents: "none",
    cursor: "not-allowed",
  },

  // Shared "field error" banner under description textareas (was raw inline sx everywhere)
  formErrorBox: {
    background: "var(--app-tint-red)",
    borderTop: "1px solid #fecaca",
  },

  // Accordion chevron rotate, consolidated out of raw `styles={{chevron:{...}}}` props
  accordionChevronRotate: {
    transition: "transform 200ms ease",
    "&[data-active]": {
      transform: "rotate(180deg)",
    },
  },
  // Manual (non-Accordion.Control) chevron rotate — toggled via className instead of inline style
  chevronRotate: {
    transition: "transform 300ms ease-in-out",
  },
  chevronRotateActive: {
    transform: "rotate(180deg)",
  },

  // Section-card header ("Client & Staff", "Essential Support", etc. — mockup `.ch2`)
  ch2: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "var(--app-text)",
    marginBottom: "14px",
    "& svg": {
      color: "var(--app-text-faint, #8A93A2)",
    },
  },

  // Card wrapper for the Essential Support / Support Plan / Intervention accordions (mockup `.dcard`)
  accordionCard: {
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "16px",
    padding: "18px",
    marginTop: "16px",
  },

  // Segmented Yes/No toggle built on top of Mantine's Radio.Group/Radio (keeps the
  // exact same component/value/onChange — only the visual chrome changes). The
  // native radio dot is hidden and the checked state is read from Mantine's own
  // `data-checked` attribute on the Radio root.
  segToggleRadioGroup: {
    display: "flex",
    gap: "8px",
    maxWidth: "240px",
    width: "100%",
  },
  segToggleRadioRoot: {
    flex: 1,
    cursor: "pointer",
    "& .mantine-Radio-body": {
      border: "1px solid var(--app-border)",
      borderRadius: "8px",
      background: "var(--app-surface)",
      height: "44px",
      boxSizing: "border-box",
      padding: "9px 8px",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
      transition: "0.15s",
    },
    "& .mantine-Radio-inner": {
      display: "none",
    },
    "& .mantine-Radio-labelWrapper": {
      marginLeft: 0,
    },
    "& .mantine-Radio-label": {
      fontFamily: "Inter",
      fontSize: "13px",
      fontWeight: 500,
      color: "var(--app-text-muted)",
      cursor: "pointer",
      paddingLeft: 0,
    },
    "&[data-checked] .mantine-Radio-body": {
      background: "rgb(255,246,233)",
      borderColor: "rgb(255,226,184)",
    },
    "&[data-checked] .mantine-Radio-label": {
      color: "rgb(122,74,0)",
      fontWeight: 600,
    },
  },

  // Description textarea + AI action bar shared wrapper (repeated across every note type)
  descTextareaWrapper: {
    border: "1px solid #e2e8f0",
    borderRadius: 12,
    background: "var(--app-surface)",
    overflow: "hidden",
    boxShadow: "0 1px 2px rgba(16,24,40,.05)",
    "&:focus-within": {
      borderColor: "#7856ff",
      boxShadow: "0 0 0 3px rgba(120,86,255,.16)",
    },
  },

  // Shared AI-assist bar paired under a description textarea (`.aibar` in mockup)
  aiBarStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "var(--app-surface-2)",
    border: "1px solid var(--app-border)",
    borderTop: "none",
    borderRadius: "0 0 8px 8px",
    padding: "8px 14px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text-muted)",
  },
  // Pairs with aiBarStyle: flattens the textarea's bottom corners/border so it reads as one control
  pairedTextarea: {
    "& .mantine-Textarea-input": {
      borderRadius: "8px 8px 0 0 !important",
      borderBottom: "none !important",
    },
  },

  // Generalized Yes/No segmented toggle (same visual pattern as incidentYesNoGroup/Option,
  // reusable outside the Incident Report section)
  segToggleGroup: {
    display: "flex",
    gap: "10px",
  },
  segToggleBtn: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px 8px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface)",
    color: "var(--app-text-muted)",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    cursor: "pointer",
    userSelect: "none",
    transition: "0.15s",
  },
  segToggleBtnActive: {
    borderColor: "rgb(255, 226, 184)",
    backgroundColor: "rgb(255, 246, 233)",
    color: "rgb(122, 74, 0)",
    fontWeight: 600,
  },

  // Sticky auto-save "Saving.../Saved" pill
  draftSavingIndicator: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    textAlign: "center",
    padding: "10px 0",
    background: "linear-gradient(180deg, var(--app-surface-2) 80%, transparent)",
  },
  draftSavingPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    padding: "6px 14px",
    borderRadius: 20,
    backgroundColor: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    boxShadow: "0px 1px 3px rgba(0,0,0,0.06)",
  },
  draftSavingDot: {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: "var(--app-primary)",
  },

  // Matches mockup's `.report-info` banner shown when a note is created via
  // "Use a Previous Note" — same shape, overridden to the amber palette used
  // for the duplicate-note case (`background:#FFF6E9;border-color:#FFE2B8;color:#B4700A`).
  duplicateInfoBanner: {
    display: "flex",
    gap: 9,
    alignItems: "flex-start",
    background: "#FFF6E9",
    border: "1px solid #FFE2B8",
    color: "#B4700A",
    borderRadius: 10,
    padding: "11px 13px",
    fontSize: 12.5,
    lineHeight: 1.45,
    marginBottom: 16,
    "& svg": {
      flex: "none",
      marginTop: 1,
    },
    "& b": {
      fontWeight: 700,
    },
  },

  // Shared shell for the draft-loading and draft-recovery sticky banners
  draftBanner: {
    position: "sticky",
    top: 0,
    zIndex: 10,
    background: "var(--app-surface)",
    borderBottom: "1px solid var(--app-border)",
    padding: "20px 16px",
    marginTop: -8,
    marginBottom: 8,
    boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
  },
  draftRecoveryIcon: {
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: "var(--app-tint-amber)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: 4,
  },
  draftContinueBtn: {
    backgroundColor: "var(--app-primary)",
    color: "var(--app-on-primary)",
    border: "1px solid var(--app-primary)",
    padding: "8px 24px",
    height: "auto",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "&:hover": {
      backgroundColor: "#F5A623",
    },
  },
  draftDiscardBtn: {
    backgroundColor: "var(--app-bg)",
    color: "var(--app-text)",
    border: "1px solid var(--app-bg)",
    padding: "8px 24px",
    height: "auto",
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },

  // Pending-approval banner shell (footer of the drawer for already-submitted notes)
  pendingBanner: {
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    padding: "14px 16px",
    borderRadius: "8px",
    border: "1px solid var(--app-border)",
    backgroundColor: "var(--app-surface-2)",
    marginBottom: "16px",
    fontFamily: "Inter",
    "& svg": {
      flexShrink: 0,
      marginTop: "2px",
    },
  },

  // ==================== View / Approve-Reject drawer (mockup viewNoteHTML) ====================
  // Matches mockup's `.dh` — plain white header, no more status-colored
  // background (that moved into vstatuscard below).
  viewDrawerHeader: {
    backgroundColor: "var(--app-surface) !important",
    borderBottom: "1px solid var(--app-border)",
  },
  viewDrawerTitle: {
    fontFamily: "Inter",
    fontSize: "21px",
    fontWeight: 700,
    color: "var(--app-text)",
  },
  viewDrawerClose: {
    color: "var(--app-text-muted)",
    "&:hover": {
      backgroundColor: "var(--app-surface-2)",
    },
  },

  // Static, always-expanded stacked entry card (mockup `.accitem`) — used in
  // place of a Mantine Accordion.Item for the view-mode outcome/goal/support
  // lists, which the mockup shows as a plain non-collapsible list.
  vAccItem: {
    border: "1px solid var(--app-border)",
    borderRadius: "10px",
    padding: "14px",
    background: "var(--app-bg)",
    marginBottom: "10px",
    "&:last-child": {
      marginBottom: 0,
    },
  },

  // Generic card shell + eyebrow header (mockup `.dcard` / `.ch2`)
  vCard: {
    background: "var(--app-surface)",
    border: "1px solid var(--app-border)",
    borderRadius: "16px",
    padding: "18px",
    marginBottom: "14px",
  },
  vCardHeading: {
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.04em",
    color: "var(--app-text)",
    marginBottom: "14px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& svg": {
      fontSize: "18px",
      color: "var(--app-text-faint, #8A93A2)",
    },
  },

  // Status card (mockup `.vstatuscard` / `.vtop` / `.vid` / `.vappr`)
  vTop: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  vId: {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
    fontSize: "12px",
    color: "var(--app-text-muted)",
  },
  vPill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    fontFamily: "Inter",
    fontSize: "12px",
    fontWeight: 600,
    borderRadius: "20px",
    padding: "3px 10px",
    border: "1px solid",
    "& .dot": {
      width: "6px",
      height: "6px",
      borderRadius: "50%",
    },
  },
  vPillOk: {
    background: "var(--ok-bg, #ECFDF3)",
    color: "var(--ok-fg, #027A48)",
    borderColor: "var(--ok-bd, #A6F4C5)",
    "& .dot": { background: "var(--ok, #12B76A)" },
  },
  vPillWarn: {
    background: "var(--warn-bg, #FFFAEB)",
    color: "var(--warn-fg, #B54708)",
    borderColor: "var(--warn-bd, #FEDF89)",
    "& .dot": { background: "var(--warn, #F79009)" },
  },
  vPillDang: {
    background: "var(--dang-bg, #FEF3F2)",
    color: "var(--dang-fg, #B42318)",
    borderColor: "var(--dang-bd, #FECDCA)",
    "& .dot": { background: "var(--dang, #F04438)" },
  },
  vAppr: {
    display: "flex",
    alignItems: "center",
    gap: "9px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--app-text)",
    marginTop: "12px",
  },
  vApprAvatar: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    background: "#F1F5F9",
    color: "#475569",
    display: "grid",
    placeItems: "center",
    fontSize: "11px",
    fontWeight: 600,
    flex: "none",
    objectFit: "cover",
  },
  vApprText: {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 500,
    color: "var(--app-text)",
    display: "block",
  },
  vApprSub: {
    fontFamily: "Inter",
    fontSize: "12px",
    color: "var(--app-text-muted)",
  },
  vReason: {
    marginTop: "10px",
    fontFamily: "Inter",
    fontSize: "13px",
    color: "var(--dang-fg, #B42318)",
    background: "var(--dang-bg, #FEF3F2)",
    border: "1px solid var(--dang-bd, #FECDCA)",
    borderRadius: "8px",
    padding: "10px 12px",
    lineHeight: 1.5,
  },

  // Client card (mockup `.vclientcard` / `.vavatar` / `.vclientname`)
  vClientCard: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  vAvatar: {
    flex: "none",
    width: "46px",
    height: "46px",
    borderRadius: "50%",
    background: "var(--app-primary-soft, #FFF6E9)",
    color: "#B4700A",
    display: "grid",
    placeItems: "center",
    fontSize: "16px",
    fontWeight: 700,
  },
  vClientLabel: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "var(--app-text-faint, #8A93A2)",
    marginBottom: "3px",
  },
  vClientName: {
    fontFamily: "Inter",
    fontSize: "19px",
    fontWeight: 700,
    color: "var(--app-text)",
    letterSpacing: "-0.01em",
  },
  vClientSub: {
    fontFamily: "Inter",
    fontSize: "13px",
    fontWeight: 500,
    color: "var(--app-text-muted)",
  },

  // Meta grid (mockup `.viewgrid` / `.vlabel` / `.vval`)
  vGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "15px 20px",
  },
  vLabel: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "var(--app-text-faint, #8A93A2)",
    marginBottom: "3px",
  },
  vVal: {
    fontFamily: "Inter",
    fontSize: "14px",
    color: "var(--app-text)",
    fontWeight: 500,
  },

  // Outcome/goal card (mockup `.goalhead` / `.goaltitle` / `.metchip`)
  vGoalHead: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "12px",
    marginBottom: "8px",
  },
  vGoalTitle: {
    fontFamily: "Inter",
    fontSize: "15px",
    fontWeight: 700,
    color: "var(--app-text)",
    letterSpacing: "-0.01em",
    lineHeight: 1.35,
  },
  vMetChip: {
    flex: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    borderRadius: "20px",
    padding: "3px 11px",
    fontFamily: "Inter",
    fontSize: "11.5px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    "&::before": {
      content: '""',
      width: "7px",
      height: "7px",
      borderRadius: "50%",
      background: "currentColor",
    },
  },
  vMetChipOk: { background: "var(--ok-bg, #ECFDF3)", color: "var(--ok-fg, #027A48)" },
  vMetChipWarn: { background: "var(--warn-bg, #FFFAEB)", color: "var(--warn-fg, #B54708)" },
  vMetChipDang: { background: "var(--dang-bg, #FEF3F2)", color: "var(--dang-fg, #B42318)" },
  vMetChipGray: { background: "var(--app-surface-2)", color: "var(--app-text-muted)" },

  // Reference pairs inside an outcome/goal card (mockup `.planref` / `.refline`)
  vPlanRef: {
    paddingBottom: "13px",
    marginBottom: "14px",
    borderBottom: "1px solid var(--app-border)",
    display: "flex",
    flexDirection: "column",
    gap: "7px",
  },
  vRefLine: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  vRefLineLabel: {
    color: "var(--app-text-faint, #8A93A2)",
    fontWeight: 700,
    textTransform: "uppercase",
    fontSize: "10.5px",
    letterSpacing: "0.03em",
  },
  vRefLineVal: {
    fontFamily: "Inter",
    fontSize: "13.5px",
    color: "var(--app-text)",
    lineHeight: 1.4,
  },

  // Start Time / End Time shown side by side inside the goal view card.
  vGoalTimeRow: {
    paddingBottom: "13px",
    marginBottom: "14px",
    borderBottom: "1px solid var(--app-border)",
    display: "flex",
    flexDirection: "row",
    gap: "48px",
  },

  // Labeled body text block (mockup `.docsec` / `.doclabel` / `.docbody`)
  vDocSec: {
    marginBottom: "14px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  vDocLabel: {
    fontFamily: "Inter",
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    color: "var(--app-text-faint, #8A93A2)",
    marginBottom: "5px",
  },
  vDocBody: {
    fontFamily: "Inter",
    fontSize: "14px",
    color: "var(--app-text)",
    lineHeight: 1.6,
    whiteSpace: "pre-wrap",
    textAlign: "justify",
  },
  // Same look as vDocLabel/vDocBody, but for an actual (readOnly) Mantine
  // Textarea/TextInput in view mode — keeps the same component instance used
  // for editing, just makes it visually indistinguishable from plain doc text.
  vDocField: {
    "& .mantine-Input-input, & .mantine-Textarea-input": {
      border: "none",
      background: "transparent",
      padding: 0,
      color: "var(--app-text)",
      fontSize: 14,
      fontFamily: "Inter",
      lineHeight: 1.6,
      cursor: "default",
    },
    "& .mantine-InputWrapper-label": {
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: 700,
      textTransform: "uppercase",
      letterSpacing: "0.04em",
      color: "var(--app-text-faint, #8A93A2)",
      marginBottom: 5,
    },
  },

  // Staff Signature card (mockup `.vsignbox` / `.vsign`)
  vSignBox: {
    border: "1px dashed var(--app-border)",
    borderRadius: "10px",
    padding: "14px 16px",
    background: "var(--app-bg)",
    marginBottom: "10px",
    "&:last-child": {
      marginBottom: 0,
    },
  },
  vSign: {
    fontFamily: "'Island Moments', 'Segoe Script', 'Bradley Hand', cursive",
    fontSize: "30px",
    color: "#334155",
    lineHeight: 1.1,
    marginBottom: "4px",
  },
  vSignImg: {
    maxHeight: "56px",
    marginBottom: "6px",
  },
  vSignSub: {
    fontFamily: "Inter",
    fontSize: "12px",
    color: "var(--app-text-muted)",
  },

  // Sticky bottom footer bar (mockup `.dfoot`) for the view/approve-reject drawer
  viewDrawerFooter: {
    display: "flex",
    gap: "12px",
    padding: "16px 24px",
    borderTop: "1px solid var(--app-border)",
    background: "var(--app-surface)",
    position: "sticky",
    bottom: 0,
    zIndex: 2,
    marginTop: "14px",
    marginLeft: "-24px",
    marginRight: "-24px",
    marginBottom: "-8px",
    width: "calc(100% + 48px)",
    "@media (max-width: 600px)": {
      marginLeft: "-12px",
      marginRight: "-12px",
      width: "calc(100% + 24px)",
    },
  },
  viewDrawerCloseBtn: {
    flex: "0 0 auto",
    padding: "9px 20px",
  },
}));

export default useStyles;
